// extracted by mini-css-extract-plugin
export default {"root":"styles_root__hLjO3","value":"styles_value__q3qnI","placeholder":"styles_placeholder__d+p93","items":"styles_items__BsMI+","item":"styles_item__sLZFj"};